module.exports = __webpack_public_path__ + "img/section-bg-package-list.83d36b39.png";